export const getCurrentCounter = (currentExpiryTime: string) => {
  const currentTime = new Date().getTime();
  const expiryTime = new Date(currentExpiryTime).getTime();
  const timeLeft = Math.max(0, Math.floor((expiryTime - currentTime) / 1000));
  return timeLeft;
};
